import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { LeadsSearchResponseDto } from "app/pages/sales-intelligence/modules/leads-search";
import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/query/key-factory/factory";
import type { TagColumnValueResponse } from "app/pages/sales-intelligence/modules/lists/types/columns";
import { opportunityListQueryKeyFactory } from "app/pages/sales-intelligence/pages/opportunity-list/query/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useUpdateTagMutation = (listId: string) => {
    const queryClient = useQueryClient();

    const updateTagInRowsCache = (tag: TagColumnValueResponse) => {
        queryClient.setQueriesData<LeadsSearchResponseDto>(
            { queryKey: opportunityListQueryKeyFactory.leadsTableData(listId, "companies") },
            (oldData) => {
                if (!oldData) {
                    return oldData;
                }

                return {
                    ...oldData,
                    rows: oldData.rows.map((row) => {
                        if (row.tag?.id === tag.Id) {
                            return { ...row, tag: { ...row.tag, title: tag.Title, colorHex: tag.ColorHex } };
                        }

                        return row;
                    }),
                };
            },
        );
    };

    return useMutation({
        mutationFn: ({ tag }: { tag: TagColumnValueResponse }) => {
            return salesApiService.listColumns.updateTag(listId, { ...tag });
        },
        onSuccess: (_data, variables) => {
            updateTagInRowsCache(variables.tag);
            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.getTags(listId) });
        },
    });
};
